import React, { useState, useRef } from 'react';
import {
    Button,
    Popper,
    Paper,
    ClickAwayListener,
    TextField,
    Box, Grid, Typography, InputAdornment,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function MontantDropdown({ min, max, onChangeMin, onChangeMax }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    return (
        <Box>
            <Button
                ref={anchorRef}
                variant="outlined"
                size="small"
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                onClick={handleToggle}
                style={{ /*height: 55, width: '100%',*/ color: '#4b4949' }}
            >
                Montant
            </Button>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                modifiers={[
                    { name: 'offset', options: { offset: [0, 8] } }
                ]}
                style={{ zIndex: 1300 }}
            >
                <ClickAwayListener onClickAway={handleClickAway}>
                    <Paper sx={{ p: 2, display: 'flex', width: '100%',
                        maxWidth: {
                        xs: '80vw',  // on extra‑small (mobile), max at 90% of viewport width
                        sm: 250,     // from “sm” (600px) up, max at 300px
                        md: 250,      // from “md” (900px) up, max at 400px
                        lg: 250      // from “md” (900px) up, max at 400px
                    }}}>
                        <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h5">
                                    Rechercher un montant
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ mb: 0 }}>
                                <TextField
                                    label="Entre"
                                    type="number"
                                    size="small"
                                    value={min}
                                    onChange={onChangeMin}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">€</InputAdornment>,
                                        inputProps: { step: '0.01', min: '0.00' }
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    sx={{
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                        '& input[type=number]::-webkit-outer-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        '& input[type=number]::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ mb: 0 }}>
                                <TextField
                                    label="Et"
                                    type="number"
                                    size="small"
                                    value={max}
                                    onChange={onChangeMax}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">€</InputAdornment>,
                                        inputProps: { step: '0.01', min: '0.00' }
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                        },
                                        '& input[type=number]::-webkit-outer-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        '& input[type=number]::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                    }}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </Box>
    )
}
